module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALYAAAASCAMAAADBo9TOAAAANlBMVEUAAAD/683/7M/30aH30aH/7M/30aH/7M/948D30aH30aH/7M/30aH30aH30aH/7M/516v84LuDHohXAAAADnRSTlMA+dDQycdubQYG9Bsb+T41bsMAAABuSURBVEjH7dDbEYQwDMVQBfKGtZP+m13TAP93hlOBRkBvJbmMVFonXIeLOS7octXR3Wnue5mQtd0bJUlFP1Yq6FU/3WwTtBGcHbsxSV/2iy87BH4maJJNUKaaoMo4Tc454JbrPm/CqHmajJnrgD+eVrM4FFZrPgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/springFestival/2/line.png
// module id = U9xu
// module chunks = 1